exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".align-center-horizontally {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: center; }\n\n.margin-left-20 {\n  margin-left: 20px !important; }\n\n.margin-top-5 {\n  margin-top: 5px !important; }\n\n.text-size-15 {\n  font-size: 15px; }\n\n.margin-top-20-datepicker {\n  margin-top: -20px !important; }\n\n.bold-font {\n  font-weight: bold; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/route_throw/route_throw.scss
// module id = 1081
// module chunks = 1